<div>
    <div class="head-section">
        <h6 class="header-text text-white">Assessments for {{details?.assessed | titlecase}}</h6>
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="close()">
            <g clip-path="url(#clip0_3558_32756)">
                <path d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345" stroke="#F00000" stroke-width="2.16781" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_3558_32756">
                    <rect width="17.3425" height="17.3425" fill="white" transform="translate(0.806641 0.748047)"/>
                </clipPath>
            </defs>
        </svg>
    </div>
    <div class="body-section">
        <div class="row justify-content-center mb-4">
            <div class="col-md-4">
                <img *ngIf="!details?.photo" src="assets/ass-user.svg" style="width: 130px;border-radius: 5px" alt="user" />
                <img *ngIf="details?.photo" src="{{details?.photo}}" style="width: 110px;border-radius: 5px" alt="user" />
            </div>
            <div class="col-md-8">

                <div class="w-100">
                    <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered">
                        <tr>
                            <th class="data-th">ASIN NUMBER:</th>
                            <td class="data-td">{{ details?.asin }}</td>
                        </tr>
                        <tr>
                            <th class="data-th">PHONE NUMBER:</th>
                            <td class="data-td">{{ details?.phoneNumber }}</td>
                        </tr>
                        <tr>
                            <th class="data-th">NAME:</th>
                            <td class="data-td">{{details?.assessed}}</td>
                        </tr>
                        <tr>
                            <th class="data-th">EMAIL:</th>
                            <td class="data-td">{{ details?.email }}</td>
                        </tr>
                        <tr>
                            <th class="data-th">ADDRESS:</th>
                            <td class="data-td">{{ details?.address | titlecase }}</td>
                        </tr>
                    </table>
                    </div><!-- /.table-responsive -->
                </div>
            </div>
        </div>

        <div style="position: relative;border: 1px solid #ccc;border-radius: 10px; background: #fff">
            <b style="position: absolute;background: #fff;padding: 0 10px;top: -12px;left: 20px">Assessment Details</b>

            <div class="row p-5">
                <div class="col-md-6">
                    <div class="input-bundled">
                        <label>Assessment Type</label>
                        <select>
                            <option>{{details?.assessmentType | removeUnderscores}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="details.assessmentType == 'BUSINESS_PREMISES'">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select class="form-control" (change)="getBusinessPremisesSubType($event)">
                            <option value="">Select type</option>
                            <option [value]="businessPremisesIncomeType?.id + '_' + businessPremisesIncomeType?.name + '_' + businessPremisesIncomeType?.amount + '_'+ businessPremisesIncomeType?.renewalAmount" *ngFor="let businessPremisesIncomeType of businessPremisesIncomeTypes">
                                {{ businessPremisesIncomeType?.name | titlecase }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="details.assessmentType == 'ASWAMA'">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select class="form-control" (change)="getAllBuildingTypesSub($event)">
                            <option value="">Select type</option>
                            <option [value]="buildingTypes?.id + '_' + buildingTypes?.name" *ngFor="let buildingTypes of buildingTypes">
                                {{ buildingTypes?.name | titlecase }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="details.assessmentType == 'ASWAMA'">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select class="form-control" (change)="getAllBuildingTypesSubTypes($event); getSubTypeAswama($event)">
                            <option value="">Select type</option>
                            <option [value]="buildingTypeSubs?.id + '_' + buildingTypeSubs?.name + '_' + buildingTypeSubs?.amount" *ngFor="let buildingTypeSubs of buildingTypeSubs">
                                {{ buildingTypeSubs?.name | titlecase }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="details.assessmentType == 'ASWAMA' && aswamaTypes =='Commercial'">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select class="form-control" (change)="getSubTypeAswama($event)">
                            <option value="">Select type</option>
                            <option [value]="buildingTypeSubs?.id + '_' + buildingTypeSubs?.name + '_' + buildingTypeSubs?.amount" *ngFor="let buildingTypeSubs of buildingTypeSubsTypes">
                                {{ buildingTypeSubs?.name | titlecase }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="details.assessmentType == 'PRESUMPTIVE_TAX'">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select class="form-control" (change)="getPresumptiveTax($event)">
                            <option value="">Select type</option>
                            <option [value]="buildingTypeSubs?.id + '_' + buildingTypeSubs?.name" *ngFor="let buildingTypeSubs of incomeTypes">
                                {{ buildingTypeSubs?.name | titlecase }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="details.assessmentType == 'PRESUMPTIVE_TAX'">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select class="form-control" (change)="getIncomeClassificationByIncomeTypeAndCategory($event)">
                            <option value="">Select Category</option>
                            <option value="SMALL">Small Business</option>
                            <option value="MEDIUM">Medium Business</option>
                            <option value="MICRO">Micro Business</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row p-5" *ngIf="amount > 0">
                <div class="col-md-6">
                    <div class="input-bundled">
                        <label>Registration Amount</label>
                        <span class="form-control">{{amount | nairaCurrency}}</span>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="renewalAmount > 0">
                    <div class="input-bundled">
                        <label>Renewal Amount</label>
                        <span class="form-control">{{renewalAmount | nairaCurrency}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer" *ngIf="amount > 0">
            <div class="action-buttons">
                <button  type="button" class="btn submit-button" (click)="submit()" [disabled]="isDownloading">
                    <b *ngIf="!isDownloading" >SUBMIT</b>
                    <b *ngIf="isDownloading"  class="spinner-border text-dark"></b>
                </button>
            </div>
        </div>
    </div>
</div>
